<script setup lang="ts">
  const { t } = useI18n()

  const props = withDefaults(
    defineProps<{
      prevBtnId: string
      nextBtnId: string
      darkTheme?: boolean
      hideFromScreenReaders?: boolean
      size?: 'md' | 'lg'
    }>(),
    {
      darkTheme: true,
      hideFromScreenReaders: false,
      size: 'md'
    }
  )

  const emit = defineEmits<{
    prevClick: []
    nextClick: []
  }>()

  const borderClass = computed(() => (props.darkTheme ? 'border-bt-blue-dark' : 'border-white'))
  const iconClass = computed(() => (props.darkTheme ? 'text-bt-blue-dark' : 'text-white'))
  const sizeClass = computed(() => (props.size === 'lg' ? 'size-12' : 'size-10'))

  const component = computed(() => (props.hideFromScreenReaders ? 'span' : 'button'))

  onMounted(() => {
    nextTick(() => {
      if (props.hideFromScreenReaders) {
        document.getElementById(props.prevBtnId)?.setAttribute('tabindex', '-1')
        document.getElementById(props.nextBtnId)?.setAttribute('tabindex', '-1')
      }
    })
  })
</script>
<template>
  <div :aria-hidden="hideFromScreenReaders">
    <component
      :is="component"
      :id="prevBtnId"
      :aria-label="hideFromScreenReaders ? undefined : t('slider.previous')"
      :type="component === 'button' ? 'button' : undefined"
      class="prev-btn cursor-pointer rounded-full border p-2"
      :class="[borderClass, sizeClass]"
      @click="emit('prevClick')"
    >
      <slot
        v-if="$slots['prev-btn']"
        name="prev-btn"
      />
      <Icon
        v-else
        name="common/chevron-left"
        :class="iconClass"
        size="md"
      />
    </component>
    <component
      :is="component"
      :id="nextBtnId"
      :aria-label="hideFromScreenReaders ? undefined : t('slider.next')"
      :type="component === 'button' ? 'button' : undefined"
      class="cursor-pointer rounded-full border p-2"
      :class="[borderClass, sizeClass]"
      @click="emit('nextClick')"
    >
      <slot
        v-if="$slots['next-btn']"
        name="next-btn"
      />
      <Icon
        v-else
        name="common/chevron-right"
        :class="iconClass"
      />
    </component>
  </div>
</template>

<style scoped>
  .swiper-button-disabled {
    opacity: 0.35;
    cursor: auto;
    pointer-events: none;
  }
</style>
